import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
// import { Http } from '@angular/http';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

// services
import { FlightDetailsService } from '../../services/flight-details.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { SharedService } from '../../../shared/services/shared-service.service';
// path globals
import { API_PATH, SUBSCRIPTION_KEY, FLIGHT_STATS, SLOT_NUMBER } from '../../globals';
// models
import { AppState } from '../../../booking/models/app-state.interface';
import { FlightAPIRequest } from '../../../booking/models/flight-request.interface';
import { ModalData } from '../../../shared/models/modal.interface';

import moment from 'moment';

declare var ga: any;
declare var exponea: any;

@Component({
  selector: 'app-flight-details',
  templateUrl: './flight-details.component.html',
  styleUrls: ['./flight-details.component.scss']
})
export class FlightDetailsComponent implements OnInit {

  @Input()
  flightData;

  @Input()
  appCopy;

  @Input()
  appAirportCopy;

  @Input()
  selectedLanguage;

  @Input()
  languageCode;

  @Input()
  isFlyback = false;

  @Output()
  cancelFlight: EventEmitter<any> = new EventEmitter;

  @Output()
  confirmFlight: EventEmitter<any> = new EventEmitter;



  private _flightStatsSubscription: Subscription;
  private productAvailability: any;

  public request: FlightAPIRequest = null;
  public flightDirection = null;
  public ukTerminal = null;
  public selectedFlight = null;
  public filteredCombinedFlights = null;
  public productAlert = '';
  public isLoading = false;
  public modalProductType = false;
  public modalData;
  public searchByFlightNumber = false;
  public timeDifferent;
  public flightStatsResponse = null;

  constructor(
    private _appStore: Store<AppState>,
    private _http: HttpClient,
    private _flightDetailsService: FlightDetailsService,
    private _errorService: ErrorHandler,
    private _sharedService: SharedService
  ) { }

  get numberOfFlightLegs() {
    return Array.from({ length: this.selectedFlight.flightStatusDetails.length - 1 }, (_, i) => i + 1);
  }

  ngOnInit() {
    this.timeDifferent = { singleRoute: 0, multiRoute: [] }
    let combinedFlights = [];
    let filteredCombinedFlights = [];

    if (this.flightData.linkedFlightConnections && this.flightData.linkedFlightConnections.length > 0) {
      combinedFlights = [].concat(this.flightData).concat(this.flightData.linkedFlightConnections);

      // filter out duplicate last leg
      filteredCombinedFlights = combinedFlights.filter((item, index, arr) => {
        return arr.findIndex(itemCompare => itemCompare.flightStatusDetails[itemCompare.flightStatusDetails.length - 1].flightNumber === item.flightStatusDetails[item.flightStatusDetails.length - 1].flightNumber) === index;
      });

      if (filteredCombinedFlights.length > 1) {
        this.selectedFlight = null;
        this.filteredCombinedFlights = filteredCombinedFlights;
        this.getTimeDifferent(this.filteredCombinedFlights)
      } else {
        this.filteredCombinedFlights = null;
        this.getTimeDifferent(this.flightData)
        this.handleSelectFlight(null, this.flightData);
      }
    } else {
      this.getTimeDifferent(this.flightData)
      this.handleSelectFlight(null, this.flightData);
    }
  }

  getTimeDifferent(flightData) {
    if (Array.isArray(flightData)) {
      let requestedTime;
      let arrivalTime;
      flightData.forEach(flight => {
        requestedTime = moment(flight.flightInfo.requestedDateTime);
        arrivalTime = moment(flight.flightStatusDetails[flight.flightStatusDetails.length - 1].arrivalDateTimeDetails.scheduledDateTimeLocal);
        const diff = arrivalTime.diff(requestedTime, 'days');
        this.timeDifferent.multiRoute.push(diff);
      });

    } else {
      let requestedTime = moment(flightData.flightInfo.requestedDateTime);
      let arrivalTime = moment(flightData.flightStatusDetails[flightData.flightStatusDetails.length - 1].arrivalDateTimeDetails.scheduledDateTimeLocal);
      this.timeDifferent.singleRoute = arrivalTime.diff(requestedTime, 'days');
    }
  }

  handleSelectFlight(event, data) {
    this.selectedFlight = data;
    this.isLoading = true;
    this.getTimeDifferent(this.flightData)
    const quoteFlightDirection = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.flightDirection;
    this.flightDirection = quoteFlightDirection ? quoteFlightDirection : this.selectedFlight.flightDirection;
    console.log()
    this.request = {
      firstLeg: {
        flightNumber: this.selectedFlight.flightStatusDetails[0].airlineCode + this.selectedFlight.flightStatusDetails[0].flightNumber,
        flightDirection: this.flightDirection,
        departureDate: this.flightDirection === 1
          ? this.selectedFlight.flightInfo.requestedDateTime
          : this.selectedFlight.flightStatusDetails[this.selectedFlight.flightStatusDetails.length - 1].arrivalDateTimeDetails.scheduledDateTimeLocal,
        isPrimary: true
      }
    };

    if (this.selectedFlight.secondaryLeg > 0) {
      this.request.firstLeg.isPrimary = this.flightDirection === 1 ? true : false;

      this.request.lastLeg = {
        flightNumber: this.selectedFlight.flightStatusDetails[this.selectedFlight.flightStatusDetails.length - 1].airlineCode + this.selectedFlight.flightStatusDetails[this.selectedFlight.flightStatusDetails.length - 1].flightNumber,
        flightDirection: this.flightDirection,
        departureDate: this.flightDirection === 1
          ? this.selectedFlight.flightStatusDetails[this.selectedFlight.flightStatusDetails.length - 1].departureDateTimeDetails.scheduledDateTimeLocal
          : this.selectedFlight.flightStatusDetails[this.selectedFlight.flightStatusDetails.length - 1].arrivalDateTimeDetails.scheduledDateTimeLocal,
        isPrimary: this.flightDirection === 2 ? true : false
      }
    }

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
      .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    this.request.slotNumber = this._sharedService.getCurrentSlotNumber();

    this._flightStatsSubscription = this._http
      .post(API_PATH + FLIGHT_STATS, this.request, { headers: headers })
      .subscribe((res: any) => {
        this.flightStatsResponse = JSON.parse(JSON.stringify(res));
        const flightData = res;
        this.isLoading = false;
        if (this.flightDirection === 1) {
          this.ukTerminal = flightData.flightStatusDetails[0].departureAirport.airportTerminal;
        } else if (this.flightDirection === 2) {
          this.ukTerminal = flightData.flightStatusDetails[flightData.flightStatusDetails.length - 1].arrivalAirport.airportTerminal;
        }

        this._appStore.dispatch({ type: 'UPDATE_FLIGHT_PRODUCTS', payload: { abc: res.productAvailability.abcAvailable, ccd: res.productAvailability.ccdAvailable, sds: res.productAvailability.sdsAvailable, isDomesticABC: res.productAvailability.isDomesticABC } });

        const flightStatusDetails = res.flightStatusDetails[0];
        const airportCodesString = this.getConnectingAirportCodesString();


        const connecting_Airport_multi = this.numberOfFlightLegs.length > 1 ? airportCodesString : null;
        const connecting_Airport_one = this.numberOfFlightLegs.length === 1 ? airportCodesString : null;

        const marketing_flight_number = data.flightStatusDetails[0].flightNumber; // marketing airline
        const flight_number = data.flightStatusDetails[0].operatingFlightNumber // operating airline
        const flight_date = moment(data.flightStatusDetails[0].departureDateTimeDetails.scheduledDateTimeLocal.replace('T', ' ')).format('YYYY-MM-DD HH:mm');
        const flight_dateArr = moment(data.flightStatusDetails[0].arrivalDateTimeDetails.scheduledDateTimeLocal.replace('T', ' ')).format('YYYY-MM-DD HH:mm');
        const departure_date = moment(flightData.flightInfo.requestedDateTime.replace('T', ' ')).format('YYYY-MM-DD HH:mm');
        const airline_code = data.flightStatusDetails[0].airlineCode;
        const origin_airport_code = data.flightStatusDetails[0].departureAirport.airportCode;
        const destination_airport_code = data.flightStatusDetails[data.flightStatusDetails.length - 1].arrivalAirport.airportCode;
        const total_booked_bags = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.bagCount;

        exponea.track('oldfunnel_flight_review', {
          airline_name: data.flightStatusDetails[0].airlineName.toLowerCase(),
          flight_number: flight_number,
          marketed_airline_code: airline_code,
          marketed_airline_name: flightStatusDetails.airlineName,
          marketed_flight_number: marketing_flight_number,
          operated_airline_code: data.flightStatusDetails[0].operatingAirlineCode,

          origin_city: data.flightStatusDetails[0].departureAirport.airportCityName,
          origin_airport_name: data.flightStatusDetails[0].departureAirport.airportName,
          origin_airport_country: data.flightStatusDetails[0].departureAirport.airportCountryName,
          origin_airport_code: origin_airport_code,

          destination_city: data.flightStatusDetails[data.flightStatusDetails.length - 1].arrivalAirport.airportCityName,
          destination_airport_name: data.flightStatusDetails[data.flightStatusDetails.length - 1].arrivalAirport.airportName,
          destination_airport_code: destination_airport_code,
          destination_airport_country: data.flightStatusDetails[data.flightStatusDetails.length - 1].arrivalAirport.airportCountryName,

          departure_date: departure_date,
          flight_date: flight_date,
          flight_arrival_date: flight_dateArr,

          flight_modal: 'old_flight',
          direct_connecting: this.numberOfFlightLegs.length === 0 ? 'Direct' : 'Connecting',
          one_connection: this.numberOfFlightLegs.length === 1 ? true : false,
          multi_connection: this.numberOfFlightLegs.length > 1 ? true : false,
          connecting_airport_one: connecting_Airport_one,
          connecting_airport_multi: connecting_Airport_multi,
          entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
        });

        if ((!flightData.productAvailability.abcAvailable && !flightData.productAvailability.ccdAvailable) || (this.isFlyback && !flightData.productAvailability.ccdAvailable)) {
          this.productAlert = 'unsupported';
          const currentUrl = location.pathname;
          const flightStatusDetails = res.flightStatusDetails[0];
          exponea.track('cant_support_flight', {
            operated_airline_name: flightStatusDetails.operatingAirlineName,
            marketed_airline_name: flightStatusDetails.airlineName,
            flight_number: flightStatusDetails.flightNumber,
            operated_flight_number: flightStatusDetails.operatingFlightNumber,
            flight_date: flightStatusDetails.departureDateTimeDetails.scheduledDate,
            entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
          });
          exponea.track('airline_not_partner', { entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct', });
          ga('send', 'event', 'Error', 'This flight isn\'t eligible for AirPortr, so we\'re sad to say we can\'t help you this time.', currentUrl);
        } else if (flightData.productAvailability.abcAvailable && !flightData.productAvailability.ccdAvailable) {
          this.productAlert = 'abc';
        } else if (!flightData.productAvailability.abcAvailable && flightData.productAvailability.ccdAvailable) {
          this.productAlert = 'ccd';
        } else {
          this.productAlert = 'none';
        }
      });
  }

  private getConnectingAirportCodesString() {
    let airportCodes = '';
    for (let i = 1; i < this.flightData.flightStatusDetails.length; i++) {
      const leg = this.flightData.flightStatusDetails[i];
      airportCodes += leg.departureAirport.airportCode;
      if (i + 1 <= this.flightData.flightStatusDetails.length - 1) {
        airportCodes += '-';
      }
    }
    return airportCodes;
  }

  handleCancelFlight(event) {
    this.cancelFlight.emit(event);
  }

  handleConfirmFlight(event, data) {
    let selectedFlight = JSON.parse(JSON.stringify(data));
    this.confirmFlight.emit({ flight: selectedFlight, flightStatsResponse: this.flightStatsResponse });
    const marketing_flight_number = data.flightStatusDetails[0].flightNumber; // marketing airline
    const flight_number = data.flightStatusDetails[0].operatingFlightNumber // operating airline
    const airline_code = data.flightStatusDetails[0].airlineCode;
    const origin_airport_code = data.flightStatusDetails[0].departureAirport.airportCode;
    const destination_airport_code = data.flightStatusDetails[data.flightStatusDetails.length - 1].arrivalAirport.airportCode;
    const total_booked_bags = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.bagCount;
    const flight_date = moment(data.flightStatusDetails[0].departureDateTimeDetails.scheduledDateTimeLocal.replace('T', ' ')).format('YYYY-MM-DD HH:mm');
    const flight_dateArr = moment(data.flightStatusDetails[0].arrivalDateTimeDetails.scheduledDateTimeLocal.replace('T', ' ')).format('YYYY-MM-DD HH:mm');

    const airportCodesString = this.getConnectingAirportCodesString();
    const connecting_Airport_multi = this.numberOfFlightLegs.length > 1 ? airportCodesString : null;
    const connecting_Airport_one = this.numberOfFlightLegs.length === 1 ? airportCodesString : null;

    exponea.track('oldfunnel_flight', {
      'airline_name': data.flightStatusDetails[0].airlineName.toLowerCase(),
      'marketed_airline_code': airline_code,
      'operated_airline_code': data.flightStatusDetails[0].operatingAirlineCode,
      'origin_city': data.flightStatusDetails[0].departureAirport.airportCityName,
      'origin_airport_name': data.flightStatusDetails[0].departureAirport.airportName,
      'destination_city': data.flightStatusDetails[data.flightStatusDetails.length - 1].arrivalAirport.airportCityName,
      'destination_airport_name': data.flightStatusDetails[data.flightStatusDetails.length - 1].arrivalAirport.airportName,
      'flight_number': flight_number,
      'marketed_flight_number': marketing_flight_number,
      'origin_airport_code': origin_airport_code,
      'destination_airport_code': destination_airport_code,
      'total_booked_bags': total_booked_bags,
      'flight_date': flight_date,
      'flight_arrival_date': flight_dateArr,
      entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
      direct_connecting: this.numberOfFlightLegs.length === 0 ? 'Direct' : 'Connecting',
      one_connection: this.numberOfFlightLegs.length === 1 ? true : false,
      multi_connection: this.numberOfFlightLegs.length > 1 ? true : false,
      connecting_airport_one: connecting_Airport_one,
      connecting_airport_multi: connecting_Airport_multi,
    });

    ga('send', 'event', 'Vanilla', 'Result - My Flight', data.flightInfo.requestFlightNumber);
    return;
  }

  toggleFlightInfoModal(airlineData) {
    let opratingAirline = '';
    let operatingAirlineCode;
    let flightData;
    if (airlineData.operatingFlightNumber) {
      flightData = airlineData;
      operatingAirlineCode = airlineData.operatingAirlineCode
      opratingAirline = operatingAirlineCode + airlineData.operatingFlightNumber;
    } else {
      flightData = airlineData.flightStatusDetails[0];
      operatingAirlineCode = airlineData.flightStatusDetails[0].operatingAirlineCode
      opratingAirline = operatingAirlineCode + airlineData.flightStatusDetails[0].operatingFlightNumber
    }
    const modalData: ModalData = {
      type: 'default',
      modalType: 'flightInfo',
      title: this.appCopy.panelHeader['flightModalHeading' + this.selectedLanguage],
      content: this.appCopy.panelHeader['flightModalOperatingAirlineTitle' + this.selectedLanguage],
      image: operatingAirlineCode,
      contentOptional: this.appCopy.panelHeader['flightModalOperatingAirlineNumberTitle' + this.selectedLanguage] + ' ' + opratingAirline,
      buttonText: '',
      cancelButtonText: this.appCopy.panelHeader['flightModalCloseBtn' + this.selectedLanguage],
      showLoader: false,
      flightData: flightData
    };
    this._errorService.handleModal(modalData);
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

}
